export default __webpack_public_path__ + "static/media/vip-card-banner.38e704c9.svg";